import React, { useState } from "react";
import { Link } from "react-router-dom";
import { track } from "@vercel/analytics";
import { useAuth } from "../../context/AuthContext";
import AuthModal from "../AuthModal/AuthModal";
import { PLAN_TIERS } from "../../utility/planTiers";
import PlanFeatureList from "./PlanFeatureList";

const PlanTierCards = ({ location = "home_plans", planCta = false }) => {
  const { user } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleRunTournament = (event) => {
    track("create_tournament_click", { location });
    if (!user) {
      event.preventDefault();
      setShowAuthModal(true);
    }
  };

  return (
    <>
      <ul className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
        {PLAN_TIERS.map((tier) => {
          const paid = Boolean(tier.key);
          let paidTo = "/pricing";
          let paidLabel = "Subscribe";
          let paidHelper = "";
          if (planCta) {
            // /pricing — Mark-locked CTAs (no "Subscribe under Plans" here).
            if (user) {
              paidTo = "/organization/plan";
              paidLabel = "Subscribe";
            } else {
              paidTo = "/create-tournament";
              paidLabel = "Create an organization";
            }
          } else {
            // Homepage Plans strip.
            paidLabel = "Subscribe";
            paidHelper = "Create an organization, then subscribe under Plans.";
            if (user) {
              paidTo = "/organization/plan";
            }
          }

          const featureLines = [...(tier.notes || []), ...tier.points];

          return (
            <li
              key={tier.name}
              className={`card-board p-6 flex flex-col ${
                tier.featured ? "ring-2 ring-brand-gold" : ""
              }`}
            >
              <h3 className="font-display font-bold text-2xl text-brand-charcoal tracking-tight">
                {tier.name}
              </h3>
              <p className="mt-3 font-display font-bold text-3xl text-brand-charcoal">
                {tier.price}
                {tier.period ? (
                  <span className="text-base font-medium text-brand-muted">
                    {" "}
                    {tier.period}
                  </span>
                ) : null}
              </p>
              <PlanFeatureList
                lines={featureLines}
                className="mt-4 space-y-2 text-sm text-brand-charcoal flex-1 list-disc pl-5"
              />
              {paid ? (
                <div className="mt-6 space-y-2">
                  <Link
                    to={paidTo}
                    onClick={
                      !user && planCta ? handleRunTournament : undefined
                    }
                    className={`inline-flex w-full items-center justify-center rounded-lg font-display font-bold tracking-wide px-4 py-2 ${
                      tier.featured
                        ? "btn-brand"
                        : "bg-brand-cream text-brand-charcoal border border-brand-charcoal/20 hover:bg-white"
                    }`}
                  >
                    {paidLabel}
                  </Link>
                  {paidHelper ? (
                    <p className="text-xs text-brand-muted text-center">
                      {paidHelper}
                    </p>
                  ) : null}
                </div>
              ) : (
                <Link
                  to="/create-tournament"
                  onClick={handleRunTournament}
                  className="mt-6 inline-flex items-center justify-center rounded-lg font-display font-bold tracking-wide px-4 py-2 bg-brand-cream text-brand-charcoal border border-brand-charcoal/20 hover:bg-white"
                >
                  Run a tournament
                </Link>
              )}
            </li>
          );
        })}
      </ul>
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
      />
    </>
  );
};

export default PlanTierCards;
